import * as Yup from 'yup'

export const PotentialInfluencerSignupSchema = Yup.object().shape({
    name: Yup.string()
    .required('Required'),
    email: Yup.string()
    .matches(/^[\w-\.]+@[\w-\.]+\.[a-zA-Z]{2,}$/, "Invalid email")
    .email('Invalid email')
    .required('Required'),
    instagram_username: Yup.string()
    .matches(/^[^@]/, 'Please do not include the @')
    .matches(/^[\w\.]+$/, 'Please enter just the username, not the full URL')
    .test('at-least-one-platform', 'Please provide at least one social media username', function(value) {
      const { tiktok_username, youtube_username, linkedin_username } = this.parent;
      const filledFields = [value, tiktok_username, youtube_username, linkedin_username].filter(Boolean).length;
      return filledFields >= 1;
    }),
    tiktok_username: Yup.string()
    .matches(/^[^@]/, 'Please do not include the @')
    .matches(/^[\w\.]+$/, 'Please enter just the username, not the full URL')
    .test('at-least-one-platform', 'Please provide at least one social media username', function(value) {
      const { instagram_username, youtube_username, linkedin_username } = this.parent;
      const filledFields = [instagram_username, value, youtube_username, linkedin_username].filter(Boolean).length;
      return filledFields >= 1;
    }),
    youtube_username: Yup.string()
    .matches(/^[^@]/, 'Please do not include the @')
    .matches(/^[\w\.]+$/, 'Please enter just the username, not the full URL')
    .test('at-least-one-platform', 'Please provide at least one social media username', function(value) {
      const { instagram_username, tiktok_username, linkedin_username } = this.parent;
      const filledFields = [instagram_username, tiktok_username, value, linkedin_username].filter(Boolean).length;
      return filledFields >= 1;
    }),
    linkedin_username: Yup.string()
    .matches(/^[^@]/, 'Please do not include the @')
    .matches(/^[\w\.]+$/, 'Please enter only the username, without spaces or the full URL.')
    .test('at-least-one-platform', 'Please provide at least one social media username', function(value) {
      const { instagram_username, tiktok_username, youtube_username } = this.parent;
      const filledFields = [instagram_username, tiktok_username, youtube_username, value].filter(Boolean).length;
      return filledFields >= 1;
    }),
    legal_age_accepted: Yup.boolean()
    .oneOf([true], 'You must confirm that you  are of legal age.')
    .required('Required'),
    privacy_policy_accepted: Yup.boolean()
    .oneOf([true], 'Confirm that you have read the privacy policy')
    .required('Required'),
    tc_accepted: Yup.boolean()
    .oneOf([true], 'You must confirm the terms of use.')
    .required('Required'),
    newsletter_opt_in: Yup.boolean()
});
